import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTES } from '@/lib/routes';
import Home from '@/pages/Home';

// Home stays synchronous (most common entry point — keeps initial paint fast).
// All other routes are lazy-loaded so their chunks ship only when visited.
const NossosDiferenciais = lazy(() => import('@/pages/NossosDiferenciais'));
const NossaEssencia = lazy(() => import('@/pages/NossaEssencia'));
const ComoFunciona = lazy(() => import('@/pages/ComoFunciona'));
const Privacidade = lazy(() => import('@/pages/Privacidade'));
const SejaNossoParceiro = lazy(() => import('@/pages/SejaNossoParceiro'));
const TrabalheConosco = lazy(() => import('@/pages/TrabalheConosco'));
const GuiaDireitoTitulares = lazy(() => import('@/pages/GuiaDireitoTitulares'));
const Denuncia = lazy(() => import('@/pages/Denuncia'));
const TermosDeUso = lazy(() => import('@/pages/TermosDeUso'));
const NotFound = lazy(() => import('@/pages/NotFound'));

/**
 * Route table — mirrors ROUTES constant + 404 fallback.
 * Keep in sync with src/lib/routes.ts when adding or removing routes.
 */
export function Router() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={ROUTES.home} element={<Home />} />
        <Route path={ROUTES.nossosDiferenciais} element={<NossosDiferenciais />} />
        <Route path={ROUTES.nossaEssencia} element={<NossaEssencia />} />
        <Route path={ROUTES.comoFunciona} element={<ComoFunciona />} />
        <Route path={ROUTES.privacidade} element={<Privacidade />} />
        <Route path={ROUTES.sejaNossoParceiro} element={<SejaNossoParceiro />} />
        <Route path={ROUTES.trabalheConosco} element={<TrabalheConosco />} />
        <Route
          path={ROUTES.guiaDireitoTitulares}
          element={<GuiaDireitoTitulares />}
        />
        <Route path={ROUTES.denuncia} element={<Denuncia />} />
        <Route path={ROUTES.termosDeUso} element={<TermosDeUso />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
